import 'rxjs/Rx';

import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import {
  throwError as observableThrowError,
  Observable,
  of as observableOf,
} from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { OperadorService } from './services/operador.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private operador: OperadorService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // console.log('asdfsdfsdf', this.router, next, state);
    if (this.operador.isOperadorLoading()) {
      return this.operador
        .profile()
        .pipe(
          map((e) => {
            if (e) {
              if (state.url != '/app/bem-vindo') {
                let op = this.operador.getOperador();

                let store = op.estabelecimento;

                if (store['periodo_teste'] != null) {
                  let test = store['periodo_teste'];
                  if (test.over) {
                    this.router.navigate(['/app/bem-vindo']);
                    return false;
                  }
                }
              }

              return true;
            } else {
              return false;
            }
          })
        )
        .pipe(
          catchError((err) => {
            this.router.navigate(['/acessar', { goTo: next.url }]);
            return Observable.of(false);
          })
        );
    } else {
      if (this.operador.getOperadorLoggedIn()) {
        if (state.url != '/app/bem-vindo') {
          let op = this.operador.getOperador();

          let store = op.estabelecimento;

          if (store['periodo_teste'] != null) {
            let test = store['periodo_teste'];
            if (test.over) {
              this.router.navigate(['/app/bem-vindo']);
              return false;
            }
          }
        }

        return true;
      } else {
        this.router.navigate(['/acessar', { goTo: next.url }]);
        return false;
      }
    }
  }
}
